import { LatLongIcon } from '@rsos/assets/icons';
import { TEXT_TRANSLATION_MANUAL_OVERRIDE } from '@rsos/capstone/src/constants/capabilities';
import ConditionalFeatureDisplay from '../../../Common/ConditionalFeatureDisplay/ConditionalFeatureDisplay';
import { useChatContext } from '../ChatContext';
import { IconButton } from './IconButton';

export const TranslationMenuButton = () => {
  const { isTranslationMenuOpen, openTranslationMenu } = useChatContext();

  return (
    <ConditionalFeatureDisplay
      dataName="chat-translation-menu-button"
      conditions={[
        { featureFlagEnabled: 'text-manual-translation-override' },
        { capabilityEnabled: TEXT_TRANSLATION_MANUAL_OVERRIDE },
      ]}
    >
      <IconButton
        title="Translation menu"
        active={isTranslationMenuOpen}
        onClick={() => openTranslationMenu(!isTranslationMenuOpen)}
      >
        <LatLongIcon width={14} height={14} color="secondaryText" />
      </IconButton>
    </ConditionalFeatureDisplay>
  );
};
